import { lazy, Suspense } from "react";
import { Loader } from "@/components";
import { redirect } from "react-router";
import { guardCheck } from "@/common/utils";
const MePage = lazy(() => import("@/pages/MePage.page"));
const UserPage = lazy(() => import("@/pages/User.page"));

const userRoute = [
  {
    path: "user/me",
    element: (
      <Suspense>
        <MePage />
      </Suspense>
    ),
  },
  {
    path: "user/:companyType/:userId",
    loader: async ({ request }: { request: Request }) => {
      const isAllowed = guardCheck(request, "user/airx/customer/vendor");
      if (!isAllowed) {
        throw redirect("/404");
      }
      return request;
    },
    element: (
      <Suspense fallback={<Loader />}>
        <UserPage />
      </Suspense>
    ),
  },
];
export default userRoute;
